import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { categories } from "@/mocks/community";

export default function CategoryStrip() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-container px-4 md:px-6">
        <SectionTitle
          eyebrow="内容板块"
          title="按板块逛，更快找到你在意的话题"
          desc="六个板块覆盖内幕、娱乐、职场、科技、生活与情感，话题榜支持按板块筛选。"
          moreTo="/topics"
          moreLabel="进入话题榜"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/topics?category=${cat.key}`}
              className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {cat.name}
                  </span>
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
                    {cat.postCount} 帖
                  </span>
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}